const init = () => {
  console.log('Module imported successfully');
}

export default init;


// WEBPACK FOOTER //
// ./src/js/main.js